'use client'

import { useEffect } from 'react'

import { Button } from '@src/components/Button/Button'
import { useSession } from '@src/hooks/useSession'
import { useLocale } from '@src/i18n/LocaleProvider'

interface LoginModalFormProps {
  onClose: () => void
  isOpen: boolean
  redirectUrl?: string
}

export function LoginModalForm({ onClose, isOpen, redirectUrl }: LoginModalFormProps) {
  const { login } = useSession()
  const { t } = useLocale('login-form')

  // Close modal when pressing ESC
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) onClose()
    }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [isOpen, onClose])

  return (
    <div className="w-full">
      <Button
        type="submit"
        size="large"
        variant="primary"
        className="mb-4 mt-5 w-full"
        onClick={() => login({ redirectUrl })}
      >
        {t('cta')}
      </Button>
    </div>
  )
}
